const hexToBuffer = (hex: string): ArrayBuffer => {
  const bytes = new Uint8Array(hex.length / 2)
  for (let i = 0; i < hex.length; i += 2) {
    bytes[i / 2] = parseInt(hex.substr(i, 2), 16)
  }
  return bytes.buffer
}

export const transformKey = async (rawKey: string): Promise<CryptoKey> => {
  const keyData = hexToBuffer(rawKey)

  try {
    // Import the key using the Web Crypto API
    const cryptoKey = await window.crypto.subtle.importKey(
      "raw", // the format of the key data
      keyData, // the key material (an ArrayBufferView)
      { name: "AES-GCM" }, // algorithm details
      false, // whether the key is extractable (can be exported later)
      ["encrypt", "decrypt"] // key usages
    )
    return cryptoKey
  } catch (error) {
    console.error("Error importing key:", error)
    throw error
  }
}

export const encryptData = async (
  key: CryptoKey,
  data: string
): Promise<{ encryptedData: string; iv: string }> => {
  const encoder = new TextEncoder()
  const iv = crypto.getRandomValues(new Uint8Array(12)) // Initialization vector (12 bytes for AES-GCM)
  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    encoder.encode(data)
  )

  // Convert encrypted data and IV to Base64 strings for storage
  return {
    encryptedData: btoa(
      String.fromCharCode.apply(null, Array.from(new Uint8Array(encrypted)))
    ),
    iv: btoa(String.fromCharCode.apply(null, Array.from(iv))),
  }
}
